import { render, staticRenderFns } from "./planet-overview-timer.vue?vue&type=template&id=770ba580&"
import script from "./planet-overview-timer.vue?vue&type=script&lang=js&"
export * from "./planet-overview-timer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports